import { useState, useEffect } from 'react';

export default function AvailabilityPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm' : 'bg-white'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center space-x-2 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/44752aaa2b8c60b6ac39ccbed2793a85/f0377fb5ec1076e4cb9e676fd4f0df74.jpeg" 
                alt="Coliving HIDA TAKAYAMA"
                className="w-8 h-8 rounded-full object-cover"
              />
              <h1 className="text-xl font-semibold text-gray-900" style={{ fontFamily: 'Noto Serif JP' }}>
                coliving HIDA TAKAYAMA
              </h1>
            </a>
            
            {/* Desktop Menu */}
            <div className="hidden md:flex space-x-6">
              <a href="/#concept" className="text-base text-gray-600 transition-colors hover:text-orange-400">About</a>
              <a href="/#rooms" className="text-base text-gray-600 transition-colors hover:text-orange-400">Rooms</a>
              <a href="/#amenities" className="text-base text-gray-600 transition-colors hover:text-orange-400">Amenities</a>
              <a href="/#location" className="text-base text-gray-600 transition-colors hover:text-orange-400">Discover</a>
              <a href="/#booking" className="text-base text-gray-600 transition-colors hover:text-orange-400">How It Works</a>
              <a href="/#faq" className="text-base text-gray-600 transition-colors hover:text-orange-400">FAQ</a>
              <a href="/availability" className="text-base text-gray-600 transition-colors hover:text-orange-400">Availability</a>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <i className={`text-2xl text-gray-900 ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <div className="px-6 py-4 space-y-4">
              <a href="/#concept" className="block text-lg text-gray-900 hover:text-orange-400 transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>About</a>
              <a href="/#rooms" className="block text-lg text-gray-900 hover:text-orange-400 transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Rooms</a>
              <a href="/#amenities" className="block text-lg text-gray-900 hover:text-orange-400 transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Amenities</a>
              <a href="/#location" className="block text-lg text-gray-900 hover:text-orange-400 transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Discover</a>
              <a href="/#booking" className="block text-lg text-gray-900 hover:text-orange-400 transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>How It Works</a>
              <a href="/#faq" className="block text-lg text-gray-900 hover:text-orange-400 transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>FAQ</a>
              <a href="/availability" className="block text-lg text-gray-900 hover:text-orange-400 transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Availability</a>
            </div>
          </div>
        )}
      </nav>

      {/* Main Content */}
      <main className="pt-20">
        <iframe 
          src="https://coliving-hida-takayama.netlify.app"
          className="w-full h-screen border-0"
          title="Booking Calendar"
        />
      </main>

      {/* Footer */}
      <footer className="bg-orange-50 text-gray-800 relative overflow-hidden">
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <img 
                  src="https://static.readdy.ai/image/44752aaa2b8c60b6ac39ccbed2793a85/f0377fb5ec1076e4cb9e676fd4f0df74.jpeg" 
                  alt="Coliving HIDA TAKAYAMA"
                  className="w-8 h-8 rounded-full object-cover"
                />
                <span className="text-xl font-bold text-gray-900" style={{ fontFamily: 'Noto Serif JP' }}>coliving HIDA TAKAYAMA</span>
              </div>
              <p className="text-gray-600 text-base leading-relaxed">
                Experience authentic Japanese living in the heart of Takayama's historic district.
              </p>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4 text-gray-900">Quick Links</h4>
              <ul className="space-y-2">
                <li><a href="/#about" className="text-gray-600 hover:text-orange-500 transition-colors text-base">About</a></li>
                <li><a href="/#rooms" className="text-gray-600 hover:text-orange-500 transition-colors text-base">Rooms</a></li>
                <li><a href="/#amenities" className="text-gray-600 hover:text-orange-500 transition-colors text-base">Amenities</a></li>
                <li><a href="/#location" className="text-gray-600 hover:text-orange-500 transition-colors text-base">Location</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4 text-gray-900">Contact</h4>
              <ul className="space-y-2 text-gray-600 text-base">
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line mt-1"></i>
                  <span>3F Paulownia Building, 3-58-11 Honmachi, Takayama, Gifu 506-0011</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  <span>info@moshimoshi.info</span>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4 text-gray-900">Follow Us</h4>
              <div className="flex gap-3">
                <a href="https://www.facebook.com/" rel="nofollow" className="w-10 h-10 flex items-center justify-center bg-gray-200 rounded-lg hover:bg-orange-200 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-xl text-gray-700"></i>
                </a>
                <a href="https://www.instagram.com/moshi_moshi_hida/" rel="nofollow" className="w-10 h-10 flex items-center justify-center bg-gray-200 rounded-lg hover:bg-orange-200 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl text-gray-700"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-orange-200 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-base">&copy; 2026 coliving HIDA TAKAYAMA is operated by NPO MOSHI MOSHI. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="/privacy-policy" className="text-gray-500 hover:text-orange-500 transition-colors text-base">Privacy Policy</a>
              <a href="/terms-of-service" className="text-gray-500 hover:text-orange-500 transition-colors text-base">Terms of Service</a>
              <a href="/legal-notice" className="text-gray-500 hover:text-orange-500 transition-colors text-base">Legal Notice</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
